import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useSearchParams } from "react-router-dom";

function Webinar() {
  const navigate = useNavigate();
  const [webinars, setWebinars] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const m = searchParams.get("m");

  // Check if user is logged in
  const member = JSON.parse(localStorage.getItem('member_user') || 'null');
  const isLoggedIn = !!member;

  const [formData, setFormData] = useState({
    nama: member?.name || '',
    hp: member?.phone ? member.phone.replace(/^62/, '') : '',
    status: 'Umum',
    webinar_id: '',
    member_id: member?.id || ''
  });

  formData.member_id = member?.id || m;

  useEffect(() => {
    const fetchWebinars = async () => {
      try {
        const response = await api.get(`/api/webinars`);
        setWebinars(response.data);
      } catch (err) {
        setError('Failed to load webinars.');
        console.error('Error fetching webinars:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchWebinars();
  }, []);

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === 'hp') {
      value = value.replace(/[^0-9+]/g, '');
      if (value.startsWith('62')) {
        value = value.slice(3);
      } else if (value.startsWith('0') || value.startsWith('62')) {
        value = value.replace(/^0|^62/, '');
      }
    }
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedWebinar = webinars.find(w => w.id == formData.webinar_id);
    if (!selectedWebinar) {
      alert('Please select a webinar.');
      return;
    }

    const idtransaction = 'conexsee-' + Math.random().toString(36).substring(2, 15);

    const formattedFormData = {
      ...formData,
      hp: `62${formData.hp}`
    };

    if (selectedWebinar.price > 0) {
      const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
      try {
        const paymentData = {
          name: formattedFormData.nama,
          number: formattedFormData.hp,
          status: formattedFormData.status,
          webinar_id: formattedFormData.webinar_id,
          transaction_id: idtransaction,
          member_id: formattedFormData.member_id
        };

        await api.post('/api/webinar-payments', paymentData);

        navigate(`/webinar/redirect/${idtransaction}`, {
          state: {
            formData: formattedFormData,
            selectedWebinar: selectedWebinar
          }
        });

      } catch (backendErr) {
        console.error('Error saat mengirim data ke backend:', backendErr);
        alert('Gagal menyimpan data pembayaran');
      }

    } else {
      console.log('Pendaftaran tanpa pembayaran');
    }
    alert('Pendaftaran berhasil!');
  };

  const formatRupiah = (number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(number);
  };

  const discountAffliate= m != null ? 5000 : 0;
  let selectedWebinarPrice =
  (webinars.find(w => w.id == formData.webinar_id)?.price || 0) - discountAffliate;
  if (selectedWebinarPrice < 0) {
    selectedWebinarPrice = 0;
  }

  if (loading) {
    return <div className="container mt-4">Loading webinars...</div>;
  }

  if (error) {
    return <div className="container mt-4" style={{ color: 'red' }}>{error}</div>;
  }

  return (
    <div className="container mt-4">
      <h2>Form Pendaftaran Webinar</h2>
      <img className="img-fluid" src="https://akad.in/storage/images/rsTxkoe9AMKHuA3oPCKBGzoc1F7U7zllgGoQ0faz.jpg" alt="Conexsee Logo" />
      <hr />
      <div class="container my-4">
          <div class="ratio ratio-16x9">
              <iframe
                  src="https://www.youtube.com/embed/i8oC38YkDyw?autoplay=1&mute=1"
                  title="YouTube video player"
                  allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen>
              </iframe>
          </div>
      </div>
      <hr />

      {isLoggedIn && (
        <div className="alert alert-info">
          <i className="bi bi-info-circle me-2"></i>
          <strong>Halo, {member.name}!</strong> Anda login sebagai <strong>{member.phone}</strong>.
        </div>
      )}

      {!isLoggedIn && (
        <div className="alert alert-warning">
          <i className="bi bi-exclamation-triangle me-2"></i>
          Anda belum login. Isi form lengkap di bawah atau <a href="/login" className="alert-link">login di sini</a>.
        </div>
      )}

      <form onSubmit={handleSubmit}>
        {/* Nama & HP — only show when NOT logged in */}
        {!isLoggedIn && (
          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="nama" className="form-label">Nama</label>
              <input
                type="text"
                className="form-control"
                id="nama"
                name="nama"
                value={formData.nama}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="hp" className="form-label">Nomor HP</label>
              <div className="input-group">
                <span className="input-group-text">62</span>
                <input
                  type="tel"
                  className="form-control"
                  id="hp"
                  name="hp"
                  value={formData.hp}
                  onChange={handleChange}
                  required
                  placeholder="81234567890"
                />
              </div>
            </div>
          </div>
        )}

        <div className="row mb-3">
          {/* Status — only show when NOT logged in */}
          {!isLoggedIn && (
            <div className="col-md-6">
              <label htmlFor="status" className="form-label">Status</label>
              <select
                className="form-select"
                id="status"
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="Umum">Umum</option>
                <option value="Mahasiswa">Pelajar</option>
              </select>
            </div>
          )}
          <div className={isLoggedIn ? "col-md-6" : "col-md-6"}>
            <label htmlFor="webinar_id" className="form-label">Pilih Webinar</label>
            <select
              className="form-select"
              id="webinar_id"
              name="webinar_id"
              value={formData.webinar_id}
              onChange={handleChange}
              required
            >
              <option value="">Pilih Webinar</option>
              {webinars.length > 0 ? (
                webinars
                  .filter(webinar => webinar.status !== 'selesai' && webinar.type !== 'kelas')
                  .map(webinar => (
                    <option key={webinar.id} value={webinar.id}>
                      {webinar.title}
                    </option>
                  ))
              ) : (
                <option value="">No webinars available</option>
              )}
            </select>
          </div>
          <div className={isLoggedIn ? "col-md-6" : "col-md-6"}>
            <label htmlFor="price" className="form-label">Biaya</label>
            <input
              type="text"
              className="form-control"
              id="price"
              value={formatRupiah(selectedWebinarPrice)}
              readOnly
            />
          </div>
        </div>

        <div className="row mb-3 d-none">
          <div className="col-md-6">
            <label htmlFor="member_id" className="form-label">member_id</label>
            <input
              type="text"
              className="form-control"
              id="member_id"
              name="member_id"
              value={formData.member_id}
              onChange={handleChange}
            />
          </div>
        </div>

        <button type="submit" className="btn btn-primary mt-5">Daftar</button>
      </form>
    </div>
  );
}

export default Webinar;
